import React from 'react'
import { result } from 'libraries/lodash'
import Clear from '@mui/icons-material/Clear'
import { styled } from '@mui/material/styles'
import MuiIconButton from '@mui/material/IconButton'
import { DOCUMENTS_MENU, QA_MENU } from 'constants/controllers'
import TealToolTip from 'components/TealToolTip'
import { comingSoonText } from 'helpers/coming-soon'

const IconButton = styled(MuiIconButton)({
  padding: 6
})

const TileInfoPopoverContent = ({ title, getUrl, sectionId, controller, nodes, remove, contentOverride }) => (
  <div
    style={{ width: 260 }}
    className='relative bt-xl b--dark-cerulean bg-faf-grey'
  >
    <div className='absolute top2 right2' onClick={remove}>
      <IconButton>
        <Clear className='hover-black' />
      </IconButton>
    </div>
    <h4 className='ml6 mr9 mt5'>{title}</h4>
    {contentOverride || <Content {...{ controller, nodes, sectionId, getUrl }} />}
    {!contentOverride && (
      <PopoverButton
        getUrl={getUrl}
        sectionId={sectionId}
      />
    )}
  </div>
)

const Content = ({ controller, nodes, sectionId, getUrl }) => {
  switch (controller) {
    case DOCUMENTS_MENU:
      return <PrecedentsContent {...{ nodes, sectionId, getUrl }} />
    case QA_MENU:
      return <QaContent {...{ getUrl, sectionId, nodes }} />
    default:
      return null
  }
}

const QaContent = ({ getUrl, sectionId, nodes }) => {
  const section = nodes[sectionId]
  if (!section || !Array.isArray(section.childSections)) {
    return null
  }
  const childNodes = section.childSections.map(childSectionId => nodes[childSectionId]).filter(Boolean)

  return (
    <ul className='list-reset pa0 ml6 mt0'>
      {childNodes.filter(node => node.active).map(({ id, title, childSections }) => {
        const isComingSoon = !childSections || childSections.length === 0
        const comingSoonLabel = comingSoonText(section.areaOfLaw, id)
        return (
          <li key={id} className='lh-solid mb5'>
            {isComingSoon
              ? (
                <TealToolTip title={comingSoonLabel} bgColor='dark' placement='right' arrow={false}>
                  <span className='dim-grey pointer hover-underline'>{title}</span>
                </TealToolTip>
                )
              : (
                <a
                  data-event-category='Tile Popover'
                  data-event-action='Click'
                  data-event-label={title}
                  className='no-underline hover-underline dim-grey'
                  href={getUrl({ sectionId, expanded: id, focusedId: id })}
                >
                  {title}
                </a>
                )}
          </li>
        )
      })}
    </ul>
  )
}

const PrecedentsContent = ({ nodes, sectionId, getUrl }) => (
  <ul className='list-reset pa0 ml6 mt0'>
    {result(nodes, [sectionId, 'childSections'], []).reduce((acc, curr) => {
      if (nodes[curr] === undefined) {
        return acc
      }

      return [
        ...acc,
        (
          <li key={curr} className='lh-solid mb5' data-testid='precedent-tile-popover-list-item'>
            <a
              className='no-underline hover-underline dim-grey'
              href={getUrl({ sectionId, focusedId: curr })}
            >
              {nodes[curr].title}
            </a>
          </li>
        )
      ]
    }, [])}
  </ul>
)

const PopoverButton = ({ getUrl, sectionId }) => (
  <div className='w-100 pa6 flex justify-center hover-o-80'>
    <a
      className='tc no-underline w-100 pa3 ma0 maauto white hover-white bg-dark-cerulean'
      href={getUrl({ sectionId })}
    >
      Open chapter
    </a>
  </div>
)

export default TileInfoPopoverContent
